// extracted by mini-css-extract-plugin
export default {"qaButton":"KHQG1hD9mM4E8U6nwdEYbw=="};